<template>
  <v-container class="minHeight">
    <div v-if="this.hasPendingContact">
      <advice color="primary">
        <span
          class="caption grey--text text--darken-1"
          v-html="$t('business.validatingBusiness.message')"
        >
        </span>
      </advice>
    </div>
    <div v-else-if="this.hasContactData">
      <v-card>
        <v-layout column wrap pa-4>
          <v-text-field
            :label="$t('business.placeholder.name')"
            v-model="model.name"
            :rules="mandatoryRules"
            :disabled="true"
            required
          ></v-text-field>
          <v-text-field
            :label="$t('business.placeholder.address')"
            v-model="model.address"
            :rules="mandatoryRules"
            :disabled="true"
            required
          ></v-text-field>
          <v-text-field
            :label="$t('business.placeholder.legalId')"
            v-model="model.legalId"
            :rules="mandatoryRules"
            :disabled="true"
            required
          ></v-text-field>
        </v-layout>
      </v-card>
    </div>
    <div v-else-if="showContactForm">
      <v-form
        ref="form"
        v-model="valid"
        v-on:submit.prevent="
          () => {
            return false;
          }
        "
      >
        <v-card>
          <v-layout column wrap pa-4>
            <v-text-field
              :label="$t('business.placeholder.name')"
              v-model="model.name"
              :rules="mandatoryRules"
              :disabled="false"
              required
            ></v-text-field>
            <v-text-field
              :label="$t('business.placeholder.address')"
              v-model="model.address"
              :rules="mandatoryRules"
              :disabled="false"
              required
            ></v-text-field>
            <v-text-field
              :label="$t('business.placeholder.legalId')"
              v-model="model.legalId"
              :rules="mandatoryRules"
              :disabled="false"
              required
            ></v-text-field>
            <v-text-field
              :label="$t('business.placeholder.email')"
              v-model="model.email"
              :rules="emailRules"
              type="email"
              :disabled="false"
              required
            ></v-text-field>
            <v-text-field
              :label="$t('business.placeholder.workers')"
              v-model="model.workers"
              :rules="mandatoryRules"
              :disabled="false"
              type="number"
              required
            ></v-text-field>
          </v-layout>

          <v-card-actions class="px-4 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="initialize"
              color="primary"
              round
              outline
              :disabled="!valid"
              :loading="isLoading"
              @click="saveForm"
              >{{ $t('global.button.save') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import businessService from '@/services/businessService';
import manageErrorService from '@/services/manageErrorService';
import Advice from '@/components/commons/Advice';

export default {
  name: 'Business',
  components: {
    [Advice.name]: Advice
  },
  computed: {
    mandatoryRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v =>
          (!!v && v.trim().length !== 0) ||
          this.$i18n.t('global.validation.required.text')
      ];
    },
    emailRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          this.$i18n.t('global.validation.email.format')
      ];
    }
  },
  data() {
    return {
      valid: false,
      isLoading: false,
      hasPendingContact: false,
      hasContactData: false,
      showContactForm: false,
      model: {
        name: '',
        address: '',
        legalId: '',
        email: '',
        workers: ''
      }
    };
  },
  created() {
    this.getBusinessDetail();
  },
  methods: {
    async getBusinessDetail() {
      let params = {};
      let results = await businessService.detail(params);

      if (results.error) {
        if (results.statuscode === 404) {
          this.checkPendingContact();
          return;
        }
        manageErrorService.handle(results.data);
        return;
      }

      this.hasContactData = true;
      this.model.name = results.data.name;
      this.model.address = results.data.address;
      this.model.legalId = results.data.identificationNumber;
    },
    async checkPendingContact() {
      let params = {};
      let results = await businessService.checkPendingContact(params);

      if (results.error) {
        if (results.statuscode === 404) {
          this.showContactForm = true;
          return;
        }
        manageErrorService.handle(results.data);
        return;
      }
      this.hasPendingContact = true;
    },
    async saveForm() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let form = {
        name: this.model.name,
        address: this.model.address,
        legalId: this.model.legalId,
        email: this.model.email,
        employees: this.model.workers
      };

      let results = await businessService.contact(form);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        return;
      }

      this.isLoading = false;
      this.editMode = false;

      this.showContactForm = false;
      this.hasPendingContact = true;
    }
  }
};
</script>
